import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  constructor(public _ui: UtilsService) { }

  ngOnInit() {
  }

}
